import { TreeItem, TreeItemProps } from '@mui/x-tree-view/TreeItem'
import React from 'react'

import theme from 'theme'

export const ConcurrentTreeItem = React.forwardRef(
  (props: TreeItemProps, ref: React.Ref<HTMLLIElement>) => {
    return (
      <TreeItem
        css={{
          '& .MuiTreeItem-iconContainer': {
            '& .close': {
              opacity: 0.3
            }
          },
          '& .MuiTreeItem-group': {
            marginLeft: 30,
            paddingLeft: 18,
            borderLeft: `1px solid ${theme.colors.gray[2]}`
          },
          '& .MuiTreeItem-content:hover': {
            background: 'inherit'
          },
          '& .MuiTreeItem-content': {
            marginBottom: theme.space[1]
          },
          '& .Mui-focused': {
            backgroundColor: 'transparent !important' // TODO wtf can't i find the origin of the backgroundColor focus setting?
          },
          '& .Mui-disabled': {
            cursor: 'not-allowed'
          }
        }}
        {...props}
        ref={ref}
      />
    )
  }
)

// required since forwardRef anonymizes the component name
ConcurrentTreeItem.displayName = 'ConcurrentTreeItem'
